// libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedNumber, FormattedDate, LocaleString } from '@biw/intl';

// shared components
import { CaretDownIcon } from 'components/library';

export class TableColumnHead extends React.Component {
    static propTypes = {
        clickCb: PropTypes.func.isRequired,
        fieldType: PropTypes.string.isRequired,
        sortedOn: PropTypes.string,
        sortedBy: PropTypes.string
    }

    handleClick = () => this.props.clickCb( this.props.fieldType )

    render() {
        const { sortedOn, sortedBy, fieldType } = this.props;
        const classNames = classnames( {
            'sorted-on': sortedOn === fieldType,
            'desc': sortedBy !== 'asc'
         } );

        return (
            <th onClick={ this.handleClick } className={ classNames }>
                <LocaleString code={ `profile.table.header.${fieldType}`} /> <div className="icon"><CaretDownIcon /></div>
            </th>
        );
    }
}

// Transaction history table
export default class Table extends React.Component {
    static propTypes = {
        accountHistory: PropTypes.shape( {
            accountHistoryList: PropTypes.array.isRequired,
            displayRows: PropTypes.array.isRequired,
            sortedOn: PropTypes.string,
            sortedBy: PropTypes.string
        } ).isRequired,
        sortAccountHistory: PropTypes.func.isRequired,
        showMoreAccountHistory: PropTypes.func.isRequired
    }

    handleSort = sortOn => this.props.sortAccountHistory( sortOn )

    handleLoadMore = event => {
        event.preventDefault();
        this.props.showMoreAccountHistory();
    }

    render() {
        const {
            accountHistory: {
                accountHistoryList,
                displayRows,
                sortedOn,
                sortedBy
            }
        } = this.props;

        return (
            <div className="data-table">
                <table>
                    <thead>
                        <tr>
                            <TableColumnHead
                                clickCb={ this.handleSort }
                                fieldType="date"
                                sortedOn={ sortedOn }
                                sortedBy={ sortedBy }
                            />
                            <TableColumnHead
                                clickCb={ this.handleSort }
                                fieldType="description"
                                sortedOn={ sortedOn }
                                sortedBy={ sortedBy }
                            />
                            <TableColumnHead
                                clickCb={ this.handleSort }
                                fieldType="amount"
                                sortedOn={ sortedOn }
                                sortedBy={ sortedBy }
                            />
                        </tr>
                    </thead>
                    <tbody>
                    { displayRows.map( ( row, i ) => (
                        <tr key={ i }>
                            <td><FormattedDate value={ row.date } /></td>
                            <td>{ row.description }</td>
                            <td><FormattedNumber value={ row.amountOrAward }/></td>
                        </tr>
                    ) ) }
                    </tbody>
                </table>

                <p className="row-count">
                    <strong>{ `1-${ displayRows.length } ` }</strong>
                    of
                    <strong>{ ` ${ accountHistoryList.length }` }</strong>
                </p>
                <p className="load-more">
                    {
                        displayRows.length < accountHistoryList.length &&
                        <a href="#" className="load-more branding-primary-text" onClick={ this.handleLoadMore }>Load Next 50</a>
                    }
                </p>
            </div>
        );
    }
}
